import { Media } from '@twilio/conversations'

export const getFileUrl = async (media: Media): Promise<string> => {
  return await media.getContentTemporaryUrl().then()
}
